import { faqs } from '@/mocks/siteData';

export default function FAQSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-3">
            常见问题
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">关于51电影网，你想知道的都在这里</p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, i) => (
            <div key={i} className="bg-background-50 border border-background-200/60 rounded-xl p-5 md:p-6">
              <h3 className="font-heading font-semibold text-base md:text-lg text-foreground-900 mb-3 flex items-start gap-3">
                <span className="flex-shrink-0 w-6 h-6 bg-primary-500 text-background-50 rounded-full flex items-center justify-center text-xs font-bold mt-0.5">
                  Q
                </span>
                {faq.q}
              </h3>
              <p className="text-foreground-600 text-sm leading-relaxed pl-9">{faq.a}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}